<div class="container">
    <div class="card-panel mt-5">
      <form [formGroup]="entidadeForm" autocomplete="off">
        <div class="row">
          <div class="col-md-8">
            <lib-page-header page-title="Usuário"
              page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}" page-change="{{pagTitulo}}"
              show-change="true" image-title="assets/img/team.png">
            </lib-page-header>
          </div>
          <div class="col-md-4">
            <a [routerLink]="['/']" class="btn btn-sm btn-outline-secondary float-right  ml-5">
              <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label style="font-weight: bold; color: #757575">
              {{login.orgao.codigo}} {{login.orgao.nome}}
            </label>
          </div>
        </div>
        <hr class="mt-0 mb-4" />
        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="form-group col-md-4">
                <label for="nome">Nome</label>
                <input formControlName="nome" type="text" class="form-control-plaintext" readonly="true" id="nome">
              </div>
              <div class="form-group col-md-4">
                <label for="sobrenome">Sobrenome</label>
                <input formControlName="sobrenome" type="text" class="form-control-plaintext" readonly="true" id="sobrenome">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
              <label for="email">e-mail</label>
              <input formControlName="email" type="email" class="form-control-plaintext" readonly="true" id="email">
          </div>
        </div>
        <hr class="mt-3 mb-2" />
        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="form-group col-md-4">
                <label for="cpf">CPF</label>
                <input formControlName="cpf" type="text" class="form-control-plaintext" readonly="true" id="cpf">
              </div>
              <div class="form-group col-md-4">
                <label for="telefone">Telefone</label>
                <input formControlName="telefone" type="tel" class="form-control-plaintext" readonly="true" id="telefone">
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-3 mb-2" />
        <div class="form-row">
          <div class="form-group col-12">

          </div>
        </div>
        <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
      </form>
    </div>
  </div>
